import React, { useState } from "react";
import Dropdown from "../components/CustomFields/Dropdown";
import InputField from "../components/CustomFields/InputField";

const ContactDetails = ({ user, setUser, errors, setErrors }) => {
  const [customRelationship, setCustomRelationship] = useState("");

  const handleContactPersonChange = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      contactPersonList: prevUser.contactPersonList.map((contact) =>
        contact.isPrimary
          ? {
              ...contact,
              [field]:
                field === "phoneNumber"
                  ? value.replace(/\D/g, "").slice(0, 10)
                  : value,
            }
          : contact
      ),
    }));

    // Clear the error when the field is updated
    if (field === "firstName" && value) {
      setErrors((prevErrors) => ({ ...prevErrors, contactFirstName: "" }));
    } else if (field === "lastName" && value) {
      setErrors((prevErrors) => ({ ...prevErrors, contactLastName: "" }));
    } else if (field === "phoneNumber" && value) {
      setErrors((prevErrors) => ({ ...prevErrors, contactPhoneNumber: "" }));
    } else if (field === "email" && value) {
      setErrors((prevErrors) => ({ ...prevErrors, contactEmail: "" }));
    } else if (field === "type" && value) {
      setErrors((prevErrors) => ({ ...prevErrors, relationship: "" }));
    }
  };

  const primaryContact = user.contactPersonList.find(
    (contact) => contact.isPrimary
  );

  // Normalize dropdown options and selected value to uppercase
  const relationshipOptions = [
    "Father",
    "Mother",
    "Guardian",
    "Friend",
    "Relative",
    "Other",
  ];

  const normalizedSelectedValue = primaryContact?.type?.toUpperCase() || "";

  return (
    <div>
      <h3 className="text-lg font-bold mb-4 text-center">Contact Details</h3>
      {primaryContact ? (
        <>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <Dropdown
              id="parentGuardian"
              label="Relationship with Student *"
              defaultOption="Select Relationship"
              options={relationshipOptions}
              value={
                relationshipOptions.find(
                  (option) => option.toUpperCase() === normalizedSelectedValue
                ) || ""
              }
              onChange={(e) => {
                const value = e.target.value.toUpperCase(); // Save in uppercase
                handleContactPersonChange("type", value);
                if (value === "OTHER") setCustomRelationship("");
              }}
              error={errors.relationship}
            />

            {primaryContact.type.toUpperCase() === "OTHER" ? (
              <>
                <InputField
                  id="customRelationship"
                  label="‎ "
                  type="text"
                  placeholder="Specify Relationship *"
                  value={customRelationship}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCustomRelationship(value);
                    handleContactPersonChange("customRelationship", value);
                  }}
                />
                <InputField
                  id="contactFirstName"
                  label="Name * "
                  type="text"
                  value={primaryContact.firstName || ""}
                  onChange={(e) =>
                    handleContactPersonChange("firstName", e.target.value)
                  }
                  error={errors.contactFirstName}
                />
                <InputField
                  id="contactLastName"
                  label="Name *"
                  type="text"
                  value={primaryContact.lastName || ""}
                  onChange={(e) =>
                    handleContactPersonChange("lastName", e.target.value)
                  }
                  error={errors.contactLastName}
                />
                <InputField
                  id="contactPhoneNumber"
                  label="Mobile Number *"
                  type="tel"
                  value={primaryContact.phoneNumber || ""}
                  onChange={(e) =>
                    handleContactPersonChange("phoneNumber", e.target.value)
                  }
                  error={errors.contactPhoneNumber}
                />
                <InputField
                  id="contactEmail "
                  label="Email Id *"
                  type="email"
                  value={primaryContact.email || ""}
                  onChange={(e) =>
                    handleContactPersonChange("email", e.target.value)
                  }
                  error={errors.contactEmail}
                />
              </>
            ) : (
              <>
                <InputField
                  id="contactFirstName"
                  label="First Name *"
                  type="text"
                  value={primaryContact.firstName || ""}
                  onChange={(e) =>
                    handleContactPersonChange("firstName", e.target.value)
                  }
                  error={errors.contactFirstName}
                />
                <InputField
                  id="contactLastName"
                  label="Last Name *"
                  type="text"
                  value={primaryContact.lastName || ""}
                  onChange={(e) =>
                    handleContactPersonChange("lastName", e.target.value)
                  }
                  error={errors.contactLastName}
                />
                <InputField
                  id="contactPhoneNumber"
                  label="Mobile Number *"
                  type="tel"
                  value={primaryContact.phoneNumber || ""}
                  onChange={(e) =>
                    handleContactPersonChange("phoneNumber", e.target.value)
                  }
                  error={errors.contactPhoneNumber}
                />
                <InputField
                  id="contactEmail"
                  label="Email Id *"
                  type="email"
                  value={primaryContact.email || ""}
                  onChange={(e) =>
                    handleContactPersonChange("email", e.target.value)
                  }
                  error={errors.contactEmail}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <p className="text-red-500 text-center">Primary contact is missing.</p>
      )}
    </div>
  );
};

export default ContactDetails;
